import { gql } from '@apollo/client'

export const CASE_DUPLICATES_QUERY = gql`
  query m2CaseDuplicates($id: ID!, $duplicateBy: M2CaseDuplicateByEnum!) {
    m2CaseDuplicates(id: $id, duplicateBy: $duplicateBy) {
      id
      project {
        title
      }
      comments
      caseState
      claimNumber
      assignedToM2At
      policyholder {
        name
        firstname
        lastname
        policyNumber
      }
      processings {
        actualProcessingType {
          title
          category
        }
        assignedProcessingType {
          title
          category
        }
      }
      rsvLegalArea {
        title
      }

      comments
    }
  }
`
